module.exports = __webpack_public_path__ + "static/media/new-york-60.0208511f.jpg";